import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import ModalComponent from "../../../../common/components/modal/modal.component";
import orderTranslationsHelper from "../../../../languages/order-translations.helper";
import { OrderCargoOrderActiveListItem } from "../../../../common/services/order/cargo-order/active-list/order-cargo-order-active-list";
import orderActiveListingStartPointsMapModalHelper from "./order-active-listing-start-points-map-modal.helper";
import MapComponent from "../../../../common/components/map/map.component";
import HorizontalSlider from "../../../../common/components/horizontal-slider/horizontal-slider.component";
import ButtonComponent from "../../../../common/components/button/button.component";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../../context/app.context";

type Props = {
  isOpen: boolean;
  onCloseClick: () => void;
  listingItems: OrderCargoOrderActiveListItem[];
};

const maxFilterHours = 14;

const OrderActiveListingStartPointsMapModalComponent: FC<Props> = (props) => {
  const [sliderValue, setSliderValue] = useState(0);
  const [filteringEnabled, setFilteringEnabled] = useState(false);

  const translations =
    orderTranslationsHelper.getActiveListingTranslations().startPointsMapModal;

  const { selectedAppLanguage } = useAppContext();

  useEffect(() => {
    if (!props.isOpen) return;

    setSliderValue(0);
    setFilteringEnabled(false);
  }, [props.isOpen]);

  const sliderValueMarkers = useMemo((): ReactNode[] => {
    const markers: ReactNode[] = [];

    for (let i = 1; i <= maxFilterHours; i++) {
      markers.push(<span>{`${i}h`}</span>);
    }

    return markers;
  }, []);

  const startPoints = useMemo(() => {
    return orderActiveListingStartPointsMapModalHelper.createFilteredStartPoints(
      props.listingItems,
      filteringEnabled,
      sliderValue + 1,
    );
  }, [props.listingItems, filteringEnabled, sliderValue]);

  const mapMarkers = useMemo(() => {
    return orderActiveListingStartPointsMapModalHelper.createMapMarkers(
      startPoints,
      translations.markerTooltipAddressTemplate,
      translations.markerTooltipDateTemplate,
    );
  }, [startPoints, selectedAppLanguage]);

  return (
    <ModalComponent
      header={{ title: translations.headingLabel }}
      isOpen={props.isOpen}
      onClose={props.onCloseClick}
    >
      <div className="order_active_listing_start_points_map_wrapper">
        <MapComponent
          markers={mapMarkers}
          autoFit
          refreshFitFlag={props.isOpen}
        />

        {filteringEnabled && (
          <>
            <div className="order_active_listing_start_points_map__slider">
              <span>{translations.timeFilterLabel}</span>
              <HorizontalSlider
                maxValue={maxFilterHours - 1}
                value={sliderValue}
                onChange={setSliderValue}
              />
              <div className="order_active_listing_start_points_map__slider__values">
                {sliderValueMarkers}
              </div>
            </div>
            <ButtonComponent
              onClick={() => setFilteringEnabled(false)}
              classNames={{ root: "map__button" }}
              title={translations.buttonDownTitle}
              type="primary"
            >
              <FontAwesomeIcon
                icon={faAngleDown}
                className="map__button__icon"
              />
            </ButtonComponent>
          </>
        )}

        {!filteringEnabled && (
          <ButtonComponent
            onClick={() => setFilteringEnabled(true)}
            classNames={{ root: "map__button" }}
            title={translations.buttonUpTitle}
            type="primary"
          >
            <FontAwesomeIcon icon={faAngleUp} className="map__button__icon" />
          </ButtonComponent>
        )}
      </div>
    </ModalComponent>
  );
};

export default OrderActiveListingStartPointsMapModalComponent;
